export default __webpack_public_path__ + "static/media/lars-klint.23fa2779.png";